import React, {useEffect, useRef} from 'react';
import {useGallery} from 'store/gallery';


const WAIT_INTERVAL = 1000;
export default function Search(props) {
   const {getList, dispatch, loading} = useGallery();
   const timer = useRef(null);

   useEffect(() => () => clearTimeout(timer.current), []);

   const triggerSearch = (key) => {
      dispatch(getList(undefined, key));
   }

   const handleSearch = (e) => {
      clearTimeout(timer.current);
      const value = e.target.value;
      timer.current = setTimeout(() => {
         triggerSearch(value)
      }, WAIT_INTERVAL);
   }
   return (
      <>

         <div className="h-10 flex w-2/6 relative border rounded">
            <input type="search" disabled={loading}
                   onChange={handleSearch}
                   className="shadow selector-dark rounded text-sm focus:outline-none px-4 w-full"
                   placeholder="جستجو بر اساس نام..."/>
            <div className="absolute top-0 left-0 mt-3 ml-4 text-violet-600">
               <svg version="1.1" className="h-4 text-violet-600 " xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 52.966 52.966" style={{enableBackground: 'new 0 0 52.966 52.966'}}
                    xmlSpace="preserve">
                  <path d="M51.704,51.273L36.845,35.82c3.79-3.801,6.138-9.041,6.138-14.82c0-11.58-9.42-21-21-21s-21,9.42-21,21s9.42,21,21,21
                                c5.083,0,9.748-1.817,13.384-4.832l14.895,15.491c0.196,0.205,0.458,0.307,0.721,0.307c0.25,0,0.499-0.093,0.693-0.279
                                C52.074,52.304,52.086,51.671,51.704,51.273z M21.983,40c-10.477,0-19-8.523-19-19s8.523-19,19-19s19,8.523,19,19
                                S32.459,40,21.983,40z"/>
               </svg>
            </div>
         </div>

      </>
   );
}
